import { useMemo } from 'react';

import { getBottomOriginItemStyle } from '../../../layout-geometry';
import { LayoutItemProps } from './layout-item.component';

interface ViewProps {
    style: React.CSSProperties;
    label?: string;
    onClick?: () => void;
    divClassName: string;
    spanClassName: string;
}

export const layoutItemDivClass = 'spotlayout-item spotlayout-item-secondary align-items-center justify-content-center w-100 h-100';
export const layoutItemSpanClass = '';

const useLayoutItem = (props: LayoutItemProps): ViewProps => {
    const divClassName = useMemo(() => {
        if (props.styles?.div) {
            if (typeof props.styles?.div === 'function') return props.styles?.div(props.slotRendering);
            else return props.styles?.div;
        } else return layoutItemDivClass;
    }, [props.styles, props.styles?.div]);
    const spanClassName = useMemo(() => {
        if (props.styles?.span) {
            if (typeof props.styles?.span === 'function') return props.styles?.span(props.slotRendering);
            else return props.styles?.span;
        } else return layoutItemSpanClass;
    }, [props.styles, props.styles?.span]);

    const label = typeof props.label === 'function' ? props.label(props.slotRendering) : props.label;
    const style = getBottomOriginItemStyle({
        x: props.slotRendering.location.x,
        y: props.slotRendering.location.y,
        width: props.slotRendering.dimension.width,
        height: props.slotRendering.dimension.height,
        minX: props.minX,
        maxY: props.maxY,
        scale: props.scale,
        overflow: 'hidden'
    });

    const onClick = () => {
        props.onClick && props.onClick(props.slotRendering);
    };

    return {
        style,
        label,
        onClick,
        divClassName,
        spanClassName
    };
};

export default useLayoutItem;
